module.exports = __webpack_public_path__ + "fonts/92b4f43a48333538e5d0e2c3e903aa77.svg";